export function convertDate(dateStr: Date) {
    if (!dateStr)
        return null;

    const date = new Date(dateStr).toLocaleString("pt-BR").split(", ");
    return `${date[0]}, às ${date[1].substring(0, date[1].length - 3)}`
}